import { Action, AnyAction } from '../action.type';
import { AppState } from '../app.state';
import {
  RetrieveFighterFrequencyBySeasonSuccessPayload,
  RetrieveUserSeasonSuccessPayload,
  RetrieveUsersTotalPointsBySeasonSuccessPayload,
  RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON,
  RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_FAILURE,
  RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_SUCCESS,
  RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON,
  RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_FAILURE,
  RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_SUCCESS,
  RETRIEVE_USER_SEASON,
  RETRIEVE_USER_SEASON_FAILURE,
  RETRIEVE_USER_SEASON_SUCCESS,
  UpsertUserSeasonSuccessPayload,
  UPSERT_USER_SEASON,
  UPSERT_USER_SEASON_FAILURE,
  UPSERT_USER_SEASON_SUCCESS,
} from './userSeason.action.type';

export const userSeasonReducer = (
  state: AppState,
  action: AnyAction,
): AppState => {
  switch (action.type) {
    case RETRIEVE_USER_SEASON:
      return retrieveUserSeasonReducer(state, action);
    case RETRIEVE_USER_SEASON_SUCCESS:
      return retrieveUserSeasonSuccessReducer(state, action);
    case RETRIEVE_USER_SEASON_FAILURE:
      return retrieveUserSeasonFailureReducer(state, action);
    case UPSERT_USER_SEASON:
      return upsertUserSeasonReducer(state, action);
    case UPSERT_USER_SEASON_SUCCESS:
      return upsertUserSeasonSuccessReducer(state, action);
    case UPSERT_USER_SEASON_FAILURE:
      return upsertUserSeasonFailureReducer(state, action);
    case RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON:
      return retrieveFighterFrequencyBySeasonReducer(state, action);
    case RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_SUCCESS:
      return retrieveFighterFrequencyBySeasonSuccessReducer(state, action);
    case RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_FAILURE:
      return retrieveFighterFrequencyBySeasonFailureReducer(state, action);
    case RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON:
      return retrieveUsersTotalPointsBySeasonReducer(state, action);
    case RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_SUCCESS:
      return retrieveUsersTotalPointsBySeasonSuccessReducer(state, action);
    case RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_FAILURE:
      return retrieveUsersTotalPointsBySeasonFailureReducer(state, action);

    default:
      return state;
  }
};

const retrieveUserSeasonReducer = (
  state: AppState,
  _action: Action<null>,
): AppState => {
  return {
    ...state,
    userSeason: {
      ...state.userSeason,
      isLoading: true,
    },
  };
};

export const retrieveUserSeasonSuccessReducer = (
  state: AppState,
  action: Action<RetrieveUserSeasonSuccessPayload>,
): AppState => {
  return {
    ...state,
    userSeason: {
      ...state.userSeason,
      seasonId: action.payload.userSeason.seasonId,
      fighters: action.payload.userSeason.fighters,
      lastUpdated: action.payload.lastUpdated,
      isLoading: false,
    },
  };
};

export const retrieveUserSeasonFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    userSeason: {
      ...state.userSeason,
      error: action.payload,
      isLoading: false,
    },
  };
};

const upsertUserSeasonReducer = (
  state: AppState,
  _action: Action<null>,
): AppState => {
  return {
    ...state,
    userSeason: {
      ...state.userSeason,
      isLoading: true,
    },
  };
};

const upsertUserSeasonSuccessReducer = (
  state: AppState,
  action: Action<UpsertUserSeasonSuccessPayload>,
): AppState => {
  return {
    ...state,
    userSeason: {
      ...state.userSeason,
      seasonId: action.payload.userSeason.seasonId,
      fighters: action.payload.userSeason.fighters,
      lastUpdated: action.payload.lastUpdated,
      isLoading: false,
    },
  };
};

const upsertUserSeasonFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    userSeason: {
      ...state.userSeason,
      error: action.payload,
      isLoading: false,
    },
  };
};

const retrieveFighterFrequencyBySeasonReducer = (
  state: AppState,
  _action: Action<null>,
): AppState => {
  return {
    ...state,
    userSeasonStats: {
      ...state.userSeasonStats,
      isLoading: true,
    },
  };
};

const retrieveFighterFrequencyBySeasonSuccessReducer = (
  state: AppState,
  action: Action<RetrieveFighterFrequencyBySeasonSuccessPayload>,
): AppState => {
  return {
    ...state,
    userSeasonStats: {
      ...state.userSeasonStats,
      fighterFrequencySeasonId: action.payload.fighterFrequency.seasonId,
      fighterFrequency: action.payload.fighterFrequency.fighterFrequency,
      isLoading: false,
    },
  };
};

const retrieveFighterFrequencyBySeasonFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    userSeasonStats: {
      ...state.userSeasonStats,
      error: action.payload,
      isLoading: false,
    },
  };
};

const retrieveUsersTotalPointsBySeasonReducer = (
  state: AppState,
  _action: Action<null>,
): AppState => {
  return {
    ...state,
    userSeasonStats: {
      ...state.userSeasonStats,
      isLoading: true,
    },
  };
};

const retrieveUsersTotalPointsBySeasonSuccessReducer = (
  state: AppState,
  action: Action<RetrieveUsersTotalPointsBySeasonSuccessPayload>,
): AppState => {
  return {
    ...state,
    userSeasonStats: {
      ...state.userSeasonStats,
      usersTotalPointsSeasonId: action.payload.usersTotalPoints.seasonId,
      usersTotalPoints: action.payload.usersTotalPoints.usersTotalPoints,
      isLoading: false,
    },
  };
};

const retrieveUsersTotalPointsBySeasonFailureReducer = (
  state: AppState,
  action: Action<string>,
): AppState => {
  return {
    ...state,
    userSeasonStats: {
      ...state.userSeasonStats,
      error: action.payload,
      isLoading: false,
    },
  };
};
